/**
 * Labstep
 *
 * @module core/TextWithMetadata
 * @desc Text with Metadata
 */

import type React from 'react';
import styles from './styles.module.scss';
import type { ITextWithMetadataProps } from './types';

export const TextWithMetadata: React.FC<ITextWithMetadataProps> = ({
  text,
  metadata,
}) => (
  <>
    {text}
    {metadata && (
      <div className={styles.metadata}>
        <small>{metadata}</small>
      </div>
    )}
  </>
);
